// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"71":"ce1f38c9d15604acda7b","866":"88f3c39e86a986fc39dc","878":"6ff47ad3f6a9c48067c8"}[chunkId] + ".css";
};